import { ExternalLink, Github } from 'lucide-react'
import { PREVIEW_APP_URL, GITHUB_REPO_URL } from '@/lib/constants'

export function ComponentsPreview() {
  return (
    <section className="bg-gray-50 py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        <div className="relative overflow-hidden rounded-3xl border border-[#448AFF]/20 bg-gradient-to-br from-[#448AFF]/10 via-[#448AFF]/5 to-transparent p-12 md:p-16">
          {/* Background decoration */}
          <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#448AFF]/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-[#448AFF]/5 blur-3xl" />

          <div className="relative">
            <h2 className="mb-4 font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
              Explore components in the live preview app
            </h2>
            <p className="mb-8 max-w-2xl text-lg text-gray-600 dark:text-white/70">
              Before installing, explore all components in a runnable demo app.
              See how tokens and components work together.
            </p>

            {/* Buttons */}
            <div className="flex flex-wrap items-center gap-4">
              <a
                href={PREVIEW_APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-xl bg-[#448AFF] px-6 py-3 text-sm font-semibold text-white transition-all hover:bg-[#448AFF]/90 hover:shadow-lg hover:shadow-[#448AFF]/25"
              >
                <ExternalLink className="h-4 w-4" />
                Open Components Preview
              </a>
              <a
                href={GITHUB_REPO_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-xl border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 transition-all hover:border-gray-400 hover:bg-gray-50 dark:border-white/20 dark:bg-white/5 dark:text-white dark:hover:border-white/30 dark:hover:bg-white/10"
              >
                <Github className="h-4 w-4" />
                View GitHub
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
